import { urlEncodedParams, getRedirectURL } from '../../factory';

function getClientID() {
    const envClientId = {
        local: '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        test:  '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        stage: '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        prod:  '921894458693-mbfubssabhc5lnbvinkp6s1hurb2peai',
    };
    let id = envClientId.prod;
    if (window.env && envClientId[window.env]) id = envClientId[window.env];
    return `${id}.apps.googleusercontent.com`;
}

const OAUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth?';
const SCOPE = 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar';

function generateParams(clientInfo) {
    return {
        response_type: 'code',
        redirect_uri: `https://${getRedirectURL()}/v4/manage/oauth2callback/google`,
        client_id: getClientID(),
        scope: SCOPE,
        access_type: 'offline',
        approval_prompt: 'auto',
        include_granted_scopes: 'true',
        state: {
            device: clientInfo.deviceInfo,
            sId: clientInfo.sId,
            eId: clientInfo.eId,
            uId: clientInfo.uId,
        },
    };
}

function googleOAuthAPI(clientInfo) {
    const p = generateParams(clientInfo);
    window.open(`${OAUTH_URL}${urlEncodedParams(p)}`, '_self');
}

export default googleOAuthAPI;
